import React from 'react';
import { View, StyleSheet } from 'react-native';
import Modal from './Modal';
import Button from './Button';

interface FormModalProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSubmit: () => void;
  submitLabel?: string;
  cancelLabel?: string;
  loading?: boolean;
  showCloseButton?: boolean;
}

const FormModal: React.FC<FormModalProps> = ({
  visible,
  onClose,
  title,
  children,
  onSubmit,
  submitLabel = 'Submit',
  cancelLabel = 'Cancel',
  loading = false,
  showCloseButton = true,
}) => {
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      title={title}
      showCloseButton={showCloseButton}
      footer={
        <View style={styles.modalActions}>
          <Button
            title={cancelLabel}
            onPress={onClose}
            variant="secondary"
            disabled={loading}
            style={styles.modalButton}
          />
          <Button
            title={submitLabel}
            onPress={onSubmit}
            variant="primary"
            disabled={loading}
            loading={loading}
            style={styles.modalButton}
          />
        </View>
      }
    >
      <View style={styles.modalFormContent}>{children}</View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: 12,
  },
  modalButton: {
    minWidth: 100,
  },
  modalFormContent: {
    gap: 8,
  },
});

export default FormModal;
